// ===========================================
// REACT QUERY CLIENT
// ===========================================

import { QueryClient } from '@tanstack/react-query';

/**
 * React Query client configuration
 * Used for server state management in both public and admin apps
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: 5 minutes
      staleTime: 5 * 60 * 1000,
      // Cache time: 10 minutes
      gcTime: 10 * 60 * 1000,
      // Retry failed requests once
      retry: 1,
      // Don't refetch on window focus in development
      refetchOnWindowFocus: import.meta.env.PROD,
    },
    mutations: {
      // Retry mutations once on failure
      retry: 1,
    },
  },
});
